import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { MatStepper } from "@angular/material";
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms";
import { UtilsService } from "src/app/services/utils.service";
import { GatheringService } from "src/app/services/gathering/gathering.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { Router } from "@angular/router";
import { CompanyService } from "src/app/services/company/company.service";
import { Observable } from "rxjs";
import { startWith, map } from "rxjs/operators";
import * as moment from "node_modules/moment/moment";
import { LoaderService } from "src/app/shared/loader/loader.service";

@Component({
	selector: "app-gathering-register",
	templateUrl: "./register.component.html",
	styleUrls: ["./register.component.scss"],
	encapsulation: ViewEncapsulation.None
})
export class GatheringRegisterComponent implements OnInit {
	@ViewChild("stepper", null) stepper: MatStepper;
	form: FormGroup;
	authenticatedUser: any;

	filteredPJs: Observable<any[]>;
	pjSearchbar: FormControl = new FormControl();
	pjs = [];
	pjSelected = "";

	constructor(
		private authService: AuthService,
		private companyService: CompanyService,
		private fb: FormBuilder,
		private gatheringService: GatheringService,
		private loaderService: LoaderService,
		private router: Router,
		private utils: UtilsService
	) {
		const current_default_date = new Date();
		this.form = this.fb.group({
			cnpj: ["", Validators.required],
			donor: this.fb.group({
				cpf: [""],
				passport: ["", [Validators.minLength(8)]],
				name: ["", Validators.required],
				birthDate: [""],
				gender: [""],
				email: ["", [Validators.email]],
				phone: ["", [Validators.minLength(8), Validators.maxLength(11)]]
			}),
			sample: this.fb.group({
				code: ["", [Validators.required, this.verifyCode]],
				gatheringDate: [moment(current_default_date).format("DD/MM/YYYY"), Validators.required],
				gatheringTime: [moment(current_default_date).format("HH:mm:ss"), Validators.required],
				insideCode: [true],
				serviceOrder: [""]
			}),
			_pcl: [null],
			_company: [null]
		});

		this.getCompanies();
	}

	ngOnInit() {
		window.location.href = 'https://pcl.elyxlab.com.br';
		this.handleAuthenticatedUser();
		this.createObservables();
	}

	handleAuthenticatedUser() {
		this.authenticatedUser = this.authService.getUser();
		if (this.authenticatedUser.userType !== "semcovid") {
			this.cnpj.clearValidators();
			this._pcl.setValue(this.authenticatedUser._pcl || null);
			this._company.setValue(this.authenticatedUser._company || null);
		}
	}

	createObservables() {
		this.filteredPJs = this.pjSearchbar.valueChanges.pipe(
			startWith(""),
			map((value: any) => (typeof value === "string" ? value : value.legalName)),
			map((name) => (name ? this.filterPJs(name) : this.pjs.slice()))
		);

		this.cpf.valueChanges.subscribe((value) => {
			if (value.length > 10) {
				this.loaderService.newLoader("Carregando dados");
				this.utils.getCPF(value).subscribe(
					(response: any) => {
						this.loaderService.stopLoader();
						this.name.setValue(response.nome);
						this.birthDate.setValue(response.nascimento);
					},
					() => this.loaderService.stopLoader()
				);
			}
		});
	}

	getCompanies() {
		this.companyService.getCompanyPCL().subscribe((res: any) => {
			this.pjs = res.data;
		});
	}

	displayFnPJ(pj?: any): string | undefined {
		return pj ? pj.legalName : undefined;
	}

	filterPJs(value: any) {
		value = value.replace(/\.|\-|\//g, "");

		return this.pjs.filter((pj) => pj.legalName.toLowerCase().indexOf(value.toLowerCase()) === 0 || pj.cnpj.toLowerCase().indexOf(value.toLowerCase()) === 0);
	}

	selectedPJ(e) {
		const selected = e.option.value;

		this._company.patchValue(null);
		this._pcl.patchValue(null);

		this.cnpj.patchValue(selected.cnpj);
		if (selected.type == "company") this._company.patchValue(selected._id);
		if (selected.type == "pcl") this._pcl.patchValue(selected._id);

		this.pjSelected = selected.legalName;
	}

	async save(data: { sample: { gatheringDate: string | Date; gatheringTime: string }; donor: { birthDate: moment.MomentInput } }) {
		// Deep Clone
		let gathering = JSON.parse(JSON.stringify(data));
		delete gathering.sample.gatheringTime;
		this.loaderService.newLoader();
		moment.locale("pt-BR");
		// if (data.sample.gatheringTime)
		gathering.sample.gatheringDate = moment(data.sample.gatheringDate + " " + data.sample.gatheringTime, "DD/MM/YYYY HH:mm:ss").toDate();
		if (data.donor.birthDate) {
			gathering.donor.birthDate = moment(data.donor.birthDate, "DD/MM/YYYY").toDate();
		}
		const res = await this.gatheringService.create(gathering).toPromise();
		this.loaderService.stopLoader();
		if (res.success) {
			this.router.navigate([`paciente/${res.gathering._id}`]);
		} else {
			alert(res.error);
		}
	}

	verifyCode(control: FormControl) {
		const parseToNumber = parseInt(control.value.charAt(1));

		if (isNaN(parseToNumber) === false) {
			return null;
		}
		if (control.value.charAt(1) === "A") {
			return null;
		}

		return { invalidCode: true };
	}

	toUpperCase(event) {
		event.target.value = event.target.value.toUpperCase();
	}
	get cnpj() {
		return this.form.get("cnpj");
	}
	get gatheringBy() {
		return this.form.get("gatheringBy");
	}
	get _pcl() {
		return this.form.get("_pcl");
	}
	get _company() {
		return this.form.get("_company");
	}

	get donor() {
		return this.form.get("donor");
	}
	get name() {
		return this.donor.get("name");
	}
	get cpf() {
		return this.donor.get("cpf");
	}
	get passport() {
		return this.donor.get("passport");
	}
	get birthDate() {
		return this.donor.get("birthDate");
	}
	get gender() {
		return this.donor.get("gender");
	}
	get email() {
		return this.donor.get("email");
	}
	get phone() {
		return this.donor.get("phone");
	}

	get sample() {
		return this.form.get("sample");
	}
	get code() {
		return this.sample.get("code");
	}
}
